import React, { useEffect } from 'react';
import { CSSTransition } from 'react-transition-group';

import { Portal } from '@xingternal/portal';

import { disableScroll, enableScroll } from '@/helpers/disable-enable-scroll';

import * as S from './full-screen-modal.styles';

type Props = {
  nested?: boolean;
  show: boolean;
};

export const FullScreenModal: React.FC<Props> = ({ children, nested, show }) => {
  useEffect(() => {
    if (show && !nested) {
      disableScroll();
    }

    return () => {
      if (!nested) {
        enableScroll();
      }
    };
  }, [show, nested]);

  return (
    <Portal>
      <CSSTransition
        aria-modal
        role="dialog"
        classNames={S.popUpWindowTransitionName}
        in={show}
        key="dialog"
        timeout={parseInt(S.popUpWindowDuration)}
        tab-index={-1}
        mountOnEnter
        unmountOnExit
      >
        <S.PopUpWindow>{children}</S.PopUpWindow>
      </CSSTransition>
    </Portal>
  );
};
